import PropTypes from 'prop-types'

import { sortKubernetesObjectParams } from 'components/attacks/create/targets/kubernetes/kubernetes-target-utils'
import {
  getAttackStageReadable,
  isInHaltingStage
} from 'components/attacks/utils/attack-stages'
import AttackTypeIcon from 'components/common/AttackTypeIcon'
import { HeptagonGlyphIcon } from 'components/common/GlyphIcon'
import { getFormattedAttackType } from 'utils/metadata'

import AttackRow, {
  AttackDescription,
  TargetsColumn,
  Status,
  HaltButton,
  DetailsChevron
} from './common/AttackRow'
import { KubernetesTargets } from './common/Targets'

export const targetCountByKind = (targets) => {
  const kinds = targets.reduce((kinds, { kind }) => {
    if (kinds[kind]) {
      kinds[kind] += 1
    } else {
      kinds[kind] = 1
    }
    return kinds
  }, {})
  const kindKeysToDisplayWithCount =
    sortKubernetesObjectParams().displayed.filter((kind) => kind in kinds)
  return kindKeysToDisplayWithCount.map((kind) => ({
    name: kind,
    count: kinds[kind]
  }))
}

export default function KubernetesAttackRow({
  attack,
  doFetch,
  clickableRow,
  selectableRow,
  onRowSelected,
  onHaltAttack,
  showHaltButton,
  checked
}) {
  const { infraAttack = {} } = attack
  const hasInfraAttack = Boolean(infraAttack?.guid)
  const args =
    attack?.attack?.impactDefinition?.cliArgs ??
    infraAttack?.infra_command?.commandArgs?.cliArgs ??
    []
  const targets = attack?.attack?.targetDefinition?.strategy?.k8sObjects ?? []
  const kindCounts = targetCountByKind(targets)
  const attackId = hasInfraAttack ? infraAttack.guid : attack.uid
  const stage = hasInfraAttack ? infraAttack.stage : attack.stage
  const isHalting = isInHaltingStage(stage)

  return (
    <AttackRow
      data-active-attack-row
      checked={checked}
      clickableRow={clickableRow}
      selectableRow={selectableRow}
      showHaltButton={showHaltButton}
      to={{
        pathname: `/attacks/kubernetes/${attack.uid}`,
        state: { k8Attack: attack, infraAttack: infraAttack }
      }}
      onRowSelected={onRowSelected}
    >
      <AttackDescription
        description={
          isHalting ? (
            'Halting...'
          ) : (
            <Status>
              {getAttackStageReadable(
                hasInfraAttack ? infraAttack.stage : attack.stage
              )}
              ...
            </Status>
          )
        }
        icon={
          <HeptagonGlyphIcon>
            <AttackTypeIcon icon={args[0]} />
          </HeptagonGlyphIcon>
        }
        name={getFormattedAttackType(args[0])}
      />
      <TargetsColumn>
        <KubernetesTargets targets={kindCounts} />
      </TargetsColumn>
      {showHaltButton && (
        <HaltButton
          fetchAttack={doFetch}
          isHalting={isHalting}
          trackingOptions={{ AttackId: attackId }}
          onConfirmRequest={onHaltAttack}
        />
      )}
      {clickableRow && <DetailsChevron />}
    </AttackRow>
  )
}

KubernetesAttackRow.propTypes = {
  attack: PropTypes.object,
  doFetch: PropTypes.func,
  onRowSelected: PropTypes.func,
  onHaltAttack: PropTypes.func,
  clickableRow: PropTypes.bool,
  showHaltButton: PropTypes.bool,
  selectableRow: PropTypes.bool,
  checked: PropTypes.bool
}
